// ======================================================================
// File Name       : ArchivementConstant
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const REPORT_STATUS = {
  NOT_SUBMITTED: 0,
  SUBMITTED: 1,
  CHECKING: 2,
  REMAND: 3,
  PENDING_APPROVAL: 4,
  APPROVAL: 5,
  RESULT_RETURN: 6,
};

export const REPORT_STATUS_TEXT = [
  { name: '未提出', value: 0 },
  { name: '提出済み', value: 1 },
  { name: '添削中', value: 2 },
  { name: '差し戻し', value: 3 },
  { name: '承認待ち', value: 4 },
  { name: '承認済み', value: 5 },
  { name: '結果返却済み', value: 6 },
];
